var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.114 2.342 12 5h2.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-8a.5.5 0 0 1 .5-.5H4l.886-2.658A.5.5 0 0 1 5.36 2h5.28a.5.5 0 0 1 .474.342M2 13h12V6h-2.72l-.23-.68L10.28 3H5.72l-.77 2.32-.23.68H2zm3.66-4.07c0-1.39.97-2.48 2.4-2.48s2.38 1.09 2.39 2.46v.06c0 1.37-.95 2.48-2.37 2.48-1.44 0-2.42-1.11-2.42-2.47zm2.41 1.52c.95 0 1.37-.74 1.37-1.48h-.01v-.06c0-.73-.43-1.46-1.38-1.46-.97 0-1.4.75-1.4 1.48v.05c0 .87.59 1.47 1.42 1.47",
  clipRule: "evenodd"
})));
export default SvgIconPhoto;